import React, { useState } from "react"
import { Control, useController } from "react-hook-form"
import {
  Flex, Stack, Text,
} from "@chakra-ui/react"
import Button from "components/Buttons/Button"
import LanguageTemplatesIcon from "components/elements/LanguageTemplatesIcon"
import FormLanguageModal from "modals/FormLanguageModal"
import { useCurrentEvent } from "queries/events"
import { useLanguageTemplates } from "queries/languageTemplates"

type Props = {
  control: Control<any>
  eventId: string
}

// This only stages the choice on the outer form's own field state (via field.onChange) —
// it never calls the API itself. The New Form / Edit Attributes flow persists it together
// with everything else on that form's own Create/Save button.
const LanguageField = ({ control, eventId }: Props) => {
  const [showLanguageModal, setShowLanguageModal] = useState(false)
  const { field } = useController({ name: "languageTemplateId", control })
  const { data: templates = [] } = useLanguageTemplates(eventId)
  const { data: event } = useCurrentEvent()

  const defaultTemplateName = templates.find(
    (template) => template.id === event.defaultLanguageTemplateId,
  )?.name ?? "English"
  const resolvedName = templates.find(
    (template) => template.id === field.value,
  )?.name ?? defaultTemplateName

  return (
    <Stack spacing={2} align="flex-start">
      <Text fontWeight="bold">Language</Text>
      <Flex align="center" gap={1}>
        <LanguageTemplatesIcon boxSize={4} color="#7ED321" />
        <Text color="#7ED321" fontWeight="semibold">{resolvedName}</Text>
      </Flex>
      <Button variant="outline" size="sm" onClick={() => setShowLanguageModal(true)}>
        Change Language
      </Button>
      {showLanguageModal && (
        <FormLanguageModal
          eventId={eventId}
          currentLanguageTemplateId={field.value ?? null}
          onClose={() => setShowLanguageModal(false)}
          onSave={(languageTemplateId) => {
            field.onChange(languageTemplateId)
            setShowLanguageModal(false)
          }}
        />
      )}
    </Stack>
  )
}

export default LanguageField
